export default function (productPrice: number, minPriceFilter: number | null, maxPriceFilter: number | null): boolean {
    if (!minPriceFilter && !maxPriceFilter) return true;

    const minPrice = minPriceFilter || 0;
    const maxPrice = maxPriceFilter || Number.MAX_VALUE;

    return productPrice >= minPrice && productPrice <= maxPrice;
}